import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  selectedMember: { ID: null, mType: null, moduleName: null, label: null },
  filterParams: {},
  memberList: [],
  memberDetails: {},
};

export const memberModuleSlice = createSlice({
  name: 'memberModule',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedMember: (state, { payload }) => {
      state.selectedMember = payload;
    },
    setMemberDetails: (state, { payload }) => {
      state.memberDetails = payload;
    },
    setMemberList: (state, { payload }) => {
      state.memberList = payload;
    },
    setFilterParams: (state, { payload }) => {
      state.filterParams = payload;
    },
  },
});

//Action creators are generated for each case reducer function
export const {
  setSelectedMember,
  setMemberDetails,
  setMemberList,
  setFilterParams,
} = memberModuleSlice.actions;

export default memberModuleSlice.reducer;
